import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Badges } from '../../models/Flow';
import { TCCPCommonService } from '../../services/tccp-common.service';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent implements OnInit {

  @Input() badges: Badges[];
  @Input() splitScreen: boolean;
  badgeList: Badges[] = [];
  public imageUrl = `${environment.baseURL}content/toyota/images/`;
  public fileExtension = 'png'
  
  constructor(public commonService: TCCPCommonService) { }

  ngOnInit() {
    this.badgeList = [];
    this.badgeList = this.sortBadgeArray(this.badges);
    this.badges.forEach(x => {
      x.image = x.badgeName === 'badges-google' ? `${this.imageUrl}badges-google.${this.fileExtension}?${(new Date()).getTime()}` :
      `${this.imageUrl}badges-apple.${this.fileExtension}?${(new Date()).getTime()}`;
    });
    this.badgeList = this.badges;
  }

  sortBadgeArray(badges: Badges[]) {
    if (badges.length > 1 && badges[0].badgeName === 'badges-apple') {
      badges = badges.sort((a, b) => b.badgeName.length - a.badgeName.length);
    }
    return badges;
  }
}
